export const FeatureName = {
    defaultFeature: "defaultFeature",
    measurementFeature: "measurementFeature"
}